import React from "react";
import "./Score.css";
import Button from "../Button/Button";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  TelegramIcon,
  TelegramShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from "react-share";
import { GameDataContext } from "../../component/Context/GameDataContext";
import { useContext } from "react";
import homeIcon from "../../Assets/img/homeIcon.png";
import retryIcon from "../../Assets/img/retryIcon.png";

const ScoreScreen = () => {
  const [clicked, setClicked] = useState(false);
  const { gameData } = useContext(GameDataContext);
  const global_data = JSON.parse(localStorage.getItem("global_data"));
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location", location?.state);

  return (
    <>
      <section className="score-section score-sec hz-score hz-score-over">
        <div className="container-1280 score-container">
          <div className="row pop-row">
            <div className="col-md-8">
              <div className={`${location?.state?.practice === true ? "big-win score score-practice" : "big-win score"}`}>
                <div className="big-win-container ">
                  <img
                    src={
                      location?.state?.practice === true
                        ? require("../../Assets/img/game-over 1.png")
                        : require("../../Assets/img/score-main.png")
                    }
                    alt="matic"
                  />
                </div>
                <div className="scrored-container">
                  <h3>Your Score</h3>
                  <div className={`${location?.state?.practice === true ? "score-number score-number-practice" : "score-number"}`}>
                    <h2>
                      {gameData.loading ? "Loading" : location?.state?.scoreProp}
                      {/* 1,002 */}
                    </h2>
                  </div>
                  {location?.state?.practice !== true ? (
                    <div className="text-score text-score-playgame">
                      <p>Winner will be Declared once the next player matches And submits the score.</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row button-row">
            <div className="col-lg-6 play-btns">
              <Button value="Home" onClick={() => navigate("/", { replace: false })} icon={homeIcon} />

              <Button
                value="Play again"
                icon={retryIcon}
                onClick={() =>
                  navigate(`/playgame/${location?.state?.gameName}`, {
                    replace: false,
                  })
                }
              />
            </div>
          </div>
          <div className="row score-row">
            <div className="col-lg-2">
              <img src={require("./../../Assets/img/discord.png")} alt="discord" />
              <h4>Join The Community</h4>
            </div>
            <div className="col-lg-8">
              <h3>{global_data?.data?.count?.total_played}</h3>
              <p>Game played till now!</p>
            </div>
            <div className="col-lg-2">
              <img src={require("./../../Assets/img/share.png")} alt="share" onClick={() => setClicked(!clicked)} />
              <h4>Share Your Achievement</h4>
            </div>
          </div>
          <div className="row social-share">
            <div className="col-lg-12">
              <div>
                {clicked ? (
                  <>
                    <FacebookShareButton
                      title="Share To Facebook"
                      url={"http://alpha.gamingarcade.io/"}
                      quote={`Hey I Have Achieved ${location?.state?.scoreProp} Score`}
                      hashtag="#GamingArcade"
                      className="Demo__some-network__share-button"
                    >
                      <FacebookIcon size={32} round />
                    </FacebookShareButton>
                    <TwitterShareButton
                      related={["RELATED_TEST"]}
                      title={`Hey I Have Achieved ${location?.state?.scoreProp} Score`}
                      url={"http://alpha.gamingarcade.io/"}
                      hashtags={["GamingArcade"]}
                      className="Demo__some-network__share-button"
                    >
                      <TwitterIcon size={32} round />
                    </TwitterShareButton>
                    <WhatsappShareButton
                      title={`Hey I Have Achieved ${location?.state?.scoreProp} Score`}
                      url={"http://alpha.gamingarcade.io/"}
                    >
                      <WhatsappIcon size={32} round />
                    </WhatsappShareButton>
                    <TelegramShareButton
                      title={`Hey I Have Achieved ${location?.state?.scoreProp} Score`}
                      url={"http://alpha.gamingarcade.io/"}
                      className="Demo__some-network__share-button"
                    >
                      <TelegramIcon size={32} round />
                    </TelegramShareButton>
                    <LinkedinShareButton
                      title={`Hey I Have Achieved ${location?.state?.scoreProp} Score`}
                      separator="HELLLO WORLD"
                      url={"http://alpha.gamingarcade.io/"}
                    >
                      <LinkedinIcon size={32} round />
                    </LinkedinShareButton>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="absolute-sm-imgs absolute-sm-imgs-score">
        <div className="ascoreimg-1">
          <img
            src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${
              location?.state?.gameName ? location?.state?.gameName : "null-image"
            }.png`}
            alt=""
          />
        </div>
        <div className="ascoreimg-2">
          <img
            src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${
              location?.state?.gameName ? location?.state?.gameName : "null-image"
            }.png`}
            alt=""
          />
        </div>
        <div className="ascoreimg-3">
          <img
            src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${
              location?.state?.gameName ? location?.state?.gameName : "null-image"
            }.png`}
            alt=""
          />
        </div>
        <div className="ascoreimg-4">
          <img
            src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${
              location?.state?.gameName ? location?.state?.gameName : "null-image"
            }.png`}
            alt=""
          />
        </div>
        <div className="ascoreimg-5">
          <img
            src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${
              location?.state?.gameName ? location?.state?.gameName : "null-image"
            }.png`}
            alt=""
          />
        </div>
        <div className="ascoreimg-6">{/* <img className="absolute-half" src={require('../../Assets/img/2048half.png')} alt="" /> */}</div>
      </section>
    </>
  );
};
export default ScoreScreen;
